.productBackground {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.dots {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(
    circle,
    color-mix(in srgb, var(--color-foreground) 20%, transparent) var(--product-dot-radius, 1px),
    transparent var(--product-dot-radius, 1px)
  );
  background-size: 24px 24px;
  background-position: 0 0;
  opacity: var(--product-dot-opacity, 0.3);
  pointer-events: none;
}
